<template>

    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">

                <div class="row no-gutters ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

                    <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
                         v-if="currentTask.testtask">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{$t('№')}}{{currentTask.pos}}.</span>{{ currentTask.testtask }}
                    </div>

                    <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
                         v-if="test.description && test.description !== currentTask.testtask">{{
                        test.description }}
                    </div>

                    <div :class="['col-lg-'+widthcol, 'col-12', 'mb-xl-4', 'mb-4', 'mt-3']">
                        <div class="row no-gutters justify-content-center d-flex align-items-center">
                            <div v-for="(item, i) in testelements"
                                 :key="i"
                                 :renderTag="forceRenderKey"
                                 v-show="item.isright==1 || step>0"
                                 :class="['col-auto', 'text-center', 'm-2', 'pa-0']"
                                 style=""
                                 @click="cardClick(item)"
                            >
                                    <div :class="['col', 'testcard', 'testcard-border', 'text-center', 'm-2', 'pa-0', 'd-flex', 'align-items-center', 'justify-content-center', item.type]">
                                            <img v-if="item.image"
                                                 :src="item.image"
                                                 class="my-1"
                                                 style="max-width: 95%; max-height: 170px; min-width: 70px"
                                            />
                                            <div
                                                    v-else
                                                    class="mt-12 justify-center">
                                                {{ item.word }}
                                            </div>
                                    </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-12 justify-content-center text-center no-gutters">
                        <button
                                v-if="step==0 && testelements.length"
                                class="btn btn-info mt-2"
                                @click="showHeap"
                        >
                            Я запомнил
                        </button>
                        <button
                                v-if="testmode==1 && step>0 && hasChecked"
                                class="btn btn-info mt-2"
                                @click="next"
                        >
                            {{ $t('accept_answer') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>
    </div>
</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<style>
    .flip-container {
        margin: 0 auto;
    }
    @media (max-width: 1024px) {
      .testcard {
        min-height: 80px;
        max-width: 80px;
        max-height: 150px;
        background-color: white;
      }
    }
</style>
<script>
    import Vue from 'vue'
    import api from '@/utils/api'
    import VueFlip from 'vue-flip'

    export default {
        name: 'Test33',
        components: {
            'vue-flip': VueFlip,
        },
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
            testmode: {default: 0},
        },
        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            cards: [],
            cardSelected: [],
            taskIdx: 0,
            audio: new Audio(),
            step: 0,
            widthcol: 12,
            errorCount: 0,
            hasChecked: 0,
            unanswered: 0,

            forceRenderKey: 0,

            showTestIntro: true,

            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
        }),

        computed: {
            currentTask: function () {
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },

        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                if (this.currentTask.idtesttask) {
                    this.hasChecked = 0
                    this.errorCount = 0
                    this.unanswered = 0
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })

                    this.testelements = response.data
                    this.testelements = this.testelements.map(e => {
                        e.correct = undefined;
                        e.type = 'secondary';
                        return e
                    })

                    this.step = 0

                } else {
                    this.$emit('testComplete')
                }
            },
            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            shuffle(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]]
                }
                return a
            },


            showHeap() {
                this.step = 1
                this.widthcol = Math.ceil(Math.sqrt(this.testelements.length)) * 2
                this.testelements = this.shuffle(this.testelements)
            },

            async cardClick(item) {
                if(!this.step) return

                if(item.correct !== undefined && this.testmode>0) {
                    item.correct = undefined
                    Vue.set(item, 'type', 'secondary')
                    this.forceRenderKey++
                } else if(this.testmode==1) {
                    Vue.set(item, 'type', 'card-answered')
                    this.forceRenderKey++
                    item.correct = !!item.isright
                } else if (item.isright) {
                    Vue.set(item, 'type', 'card-correct')
                    this.forceRenderKey++
                    item.correct = true
                    if (item.audio) {
                        this.play(item.audio)
                    } else {
                        this.play(this.okChord)
                    }
                } else {
                    Vue.set(item, 'type', 'card-wrong')
                    this.forceRenderKey++
                    item.correct = false
                    this.play(this.errorChord)
                }


                this.unanswered = 0
                this.errorCount = 0
                this.hasChecked = 0
                this.testelements.forEach(function (e) {
                    if (e.correct === false) this.errorCount++
                    if(e.isright && e.correct === undefined) this.unanswered++
                    if(e.correct !== undefined) this.hasChecked++
                }, this)

                // this.complete = !this.errorCount && !this.unanswered

                if (this.testmode==0 && !this.unanswered) {
                    await this.sleep(2000)
                    this.next()
                }
            },

            next: async function () {
                if (!this.unanswered && !this.errorCount) {
                    this.$emit('correctAnswer')
                } else this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: `Неправильно выбрано элементов: ${this.errorCount + this.unanswered}.`})
                this.taskIdx++
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            // console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },
        },
    }
</script>
